import {
  createEffect,
  createSignal,
  JSXElement,
  mergeProps,
  Show
} from 'solid-js';
import Request from '~/api/Request.ts';
import { AppErrors } from '~/components/ErrorBoundaries/utils.ts';
import { HttpStatusCode } from 'axios';
import { getSlug, HostedAuthPaths } from '~/components/AppRouter/utils.ts';

type EnvAppPagesApiConnectorProps = {
  children: JSXElement;
};

export default function EnvAppPagesApiConnector(
  props: EnvAppPagesApiConnectorProps
): JSXElement {
  const merged = mergeProps({}, props);
  const [errorCode, setErrorCode] = createSignal<AppErrors | null>(null);

  createEffect(() => {
    if (errorCode() === AppErrors.ENV_PAGES_UNAUTHORIZED) {
      window.location.assign(
        getSlug.hostedAuthPages(HostedAuthPaths.LOGIN, true)
      );
    } else if (errorCode() === AppErrors.NO_AVAILABLE_CONNECTIONS) {
      throw new Error(AppErrors.NO_AVAILABLE_CONNECTIONS);
    } else if (errorCode() === AppErrors.ENV_APP_FORBIDDEN_USER) {
      window.location.assign(getSlug.getEnvAppPagesBaseNamespace());
    }
  });

  new Request({
    onResponseError: (error) => {
      // Handle unauthorized responses
      // and throw propagate to error boundary
      if (error?.status === HttpStatusCode.Unauthorized) {
        setErrorCode(AppErrors.ENV_PAGES_UNAUTHORIZED);
      } else if (error?.status === HttpStatusCode.BadRequest) {
        const data = JSON.parse(error.response.data);
        if (data.details[0].error_code === AppErrors.NO_AVAILABLE_CONNECTIONS) {
          setErrorCode(AppErrors.NO_AVAILABLE_CONNECTIONS);
        }
      } else if (error?.status === HttpStatusCode.Forbidden) {
        setErrorCode(AppErrors.ENV_APP_FORBIDDEN_USER);
      }
      return Promise.reject(error);
    }
  });
  return <Show when={!errorCode()}>{merged.children}</Show>;
}
